import store from "../store/index";
import { createRouter, createWebHistory } from 'vue-router'
import { getBrandName } from '@/assets/js/whiteLabel';

const routes = [
    {
        path: "/",
        name: "Home",
        component: () => import("../views/QuickStart.vue"),
        meta: {
            alias: "Home",
            requiresAuth: true,
        },
    },
    {
        path: "/start",
        redirect: "/",
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("../views/Register.vue"),
        meta: {
            alias: "Registration",
        },
    },
    {
        path: "/settings",
        name: "Settings",
        component: () => import("../views/Settings.vue"),
        meta: {
            alias: "Settings",
            requiresAuth: true,
        },
    },
    {
        path: "/settings/:section",
        name: "SettingsSection",
        component: () => import("../views/Settings.vue"),
        meta: {
            alias: "Settings",
            requiresAuth: true,
        },
    },
    {
        path: "/activate-account",
        name: "ActiveAccount",
        component: () => import("../views/ActiveAccount.vue"),
        meta: {
            alias: "ActiveAccount",
        },
    },
    {
        path: "/verify-account",
        name: "VerifyAccount",
        component: () => import("../views/VerifyAccount.vue"),
        meta: {
            alias: "VerifyAccount",
        },
    },
    {
        path: "/login",
        name: "Login",
        component: () => import("../views/Login.vue"),
        meta: {
            alias: "Log In",
        },
    },
    {
        path: "/setup-2fa",
        name: "Setup2FA",
        component: () => import("../views/Setup2FA.vue"),
        meta: {
            alias: "Setup 2FA",
        },
    },
    {
        path: "/forgotPassword",
        name: "LostPassword",
        component: () => import("../views/LostPassword.vue"),
        meta: {
            alias: "Forgot Password",
        },
    },
    {
        path: "/terms-of-service",
        name: "TOS",
        component: () => import("../views/TOS.vue"),
        meta: {
            alias: "Terms Of Service",
        },
    },
    {
        path: "/privacy-policy",
        name: "PrivacyPolicy",
        component: () => import("../views/Privacy.vue"),
        meta: {
            alias: "Privacy Policy",
        },
    },
    {
        path: "/download",
        name: "Download",
        component: () => import("../views/Download.vue"),
        meta: {
            alias: "Downloads",
        },
    },
    {
        path: "/faq",
        name: "FAQ",
        component: () => import("../views/FAQ.vue"),
        meta: {
            alias: "FAQ",
        },
    },
    {
        path: "/tutorials",
        name: "Tutorials",
        component: () => import("../views/Tutorials.vue"),
        meta: {
            alias: "Tutorials",
        },
    },
    {
        path: "/resetpassword/:hash",
        name: "ResetPassword",
        component: () => import("../views/ResetPassword.vue"),
        meta: {
            alias: "Reset Password",
        },
    },
    {
        path: "/now/:id",
        name: "Now",
        component: () => import("../views/Meeting.vue"),
        meta: {
            alias: "Meeting",
        },
    },
    {
        path: "/calendar",
        name: "Calendar",
        component: () => import("../views/Calendar.vue"),
        meta: {
            alias: "Calendar",
            requiresAuth: true,
        },
    },
    {
        path: "/calendar/:view",
        name: "CalendarDetails",
        redirect: "/calendar/week/date",
        meta: {
            alias: "Calendar",
        },
    },
    {
        path: "/calendar/:view/:date",
        name: "CalendarDate",
        component: () => import("../views/Calendar.vue"),
        meta: {
            alias: "Calendar",
            requiresAuth: true,
        },
    },
    {
        path: "/schedule/:edit",
        name: "ScheduleEdit",
        component: () => import("../views/Schedule.vue"),
        meta: {
            alias: "Edit your Meeting",
            requiresAuth: true,
        },
    },
    {
        path: "/schedule",
        name: "Schedule",
        component: () => import("../views/Schedule.vue"),
        meta: {
            alias: "Schedule A Meeting",
            requiresAuth: true,
        },
    },
    {
        path: "/admin",
        name: "Admin",
        component: () => import("../views/Admin/Admin.vue"),
        meta: {
            alias: "Admin",
            requiresAuth: true,
        },
    },
    {
        path: "/admin-dashboard",
        name: "AdminDashboard",
        component: () => import("../views/Admin/Admin.vue"),
        meta: {
            alias: "Admin Dashboard",
            requiresAuth: true,
        },
    },
    {
        path: "/admin-dashboard/recordings",
        name: "AdminDashboardRecordings",
        component: () => import("../views/Admin/AdminRecordings.vue"),
        meta: {
            alias: "Admin Recordings",
            requiresAuth: true,
        },
    },
    {
        path: "/admin-dashboard/support-tickets",
        name: "AdminDashboardSupportTickets",
        component: () => import("../views/Admin/AdminSupportTickets.vue"),
        meta: {
            alias: "Admin Support Tickets",
            requiresAuth: true,
        },
    },
    {
        path: "/admin-dashboard/support-tickets/:id",
        name: "AdminDashboardSupportTicketDetail",
        component: () => import("../views/Admin/AdminTicketDetail.vue"),
        meta: {
            alias: "Admin Support Ticket Detail",
            requiresAuth: true,
        },
    },
    {
        path: "/admin/users",
        name: "AdminUsers",
        component: () => import("../views/Admin/Users.vue"),
        meta: {
            alias: "Users",
            requiresAuth: true,
        },
    },
    {
        path: "/admin/user/:id",
        name: "UserDetail",
        component: () => import("../views/Admin/UserDetail.vue"),
        meta: {
            alias: "User Detail",
            requiresAuth: true,
        },
    },
    {
        path: "/support",
        name: "Support",
        component: () => import("../views/Support.vue"),
        meta: {
            alias: "Support",
            requiresAuth: true,
        },
    },
    {
        path: "/open-ticket",
        name: "Open-Ticket",
        component: () => import("../views/SupportOpenTicket.vue"),
        meta: {
            alias: "Support",
            requiresAuth: true,
        },
    },
    {
        path: "/view-ticket/:id",
        name: "View Ticket",
        component: () => import("../views/SupportViewTicket.vue"),
        meta: {
            alias: "ViewTicket",
            requiresAuth: true,
        },
    },
    {
        path: "/attendees",
        name: "Attendees",
        component: () => import("../views/Attendees.vue"),
        meta: {
            alias: "Attendees",
            requiresAuth: true,
        },
    },
    {
        path: "/recordings",
        name: "Recordings",
        component: () => import("../views/Recordings.vue"),
        meta: {
            alias: "Recordings",
            requiresAuth: true,
        },
    },
    {
        path: "/recordings/:id",
        name: "RecordingDetail",
        component: () => import("../views/RecordingDetail.vue"),
        meta: {
            alias: "Recording Details",
            requiresAuth: true,
        },
    },
    {
        path: "/share/video/:hash",
        name: "SharedVideo",
        component: () => import("../views/SharedVideo.vue"),
        meta: {
            alias: "Shared Video",
        },
    },
    {
        path: "/rate",
        name: "Rate",
        component: () => import("../views/RateExperience.vue"),
        meta: {
            alias: "Rate Me",
        },
    },
    {
        // the booking management page moved into the quick-start "Let them book" tab
        path: "/booking",
        redirect: () => ({ path: "/", query: { tab: "book" } }),
    },
    {
        path: "/book/accept-counter/:token?",
        name: "AcceptCounterProposal",
        component: () => import("../views/AcceptCounterProposal.vue"),
        meta: {
            alias: "Accept Counter-Proposal",
        },
    },
    {
        path: "/book/:token",
        name: "Booking",
        component: () => import("../views/Booking.vue"),
        meta: {
            alias: "Book a Meeting",
        },
    },
    {
        path: "/request-delete-account",
        name: "RequestDeleteAccount",
        component: () => import("../views/RequestDeleteAccount.vue"),
        meta: {
            alias: "Request Account Deletion",
        },
    },
    {
        path: "/confirm-delete-account/:token",
        name: "ConfirmDeleteAccount",
        component: () => import("../views/ConfirmDeleteAccount.vue"),
        meta: {
            alias: "Confirm Account Deletion",
        },
    },
    {
        path: "/admin-dashboard/deletion-requests",
        name: "AdminDeletionRequests",
        component: () => import("../views/Admin/AdminDeletionRequests.vue"),
        meta: {
            alias: "Deletion Requests",
            requiresAuth: true,
        },
    },
    {
        path: "/admin-dashboard/partners",
        name: "AdminPartners",
        component: () => import("../views/Admin/Partners.vue"),
        meta: {
            alias: "Partners",
            requiresAuth: true,
        },
    },
    {
        path: "/admin-dashboard/users",
        name: "AdminDashboardUsers",
        component: () => import("../views/Admin/AdminUsers.vue"),
        meta: {
            alias: "Users",
            requiresAuth: true,
        },
    },
    {
        path: "/admin-stripe-dashboard",
        name: "AdminStripeDashboard",
        component: () => import("../views/Admin/AdminStripeDashboard.vue"),
        meta: {
            alias: "Stripe Dashboard",
            requiresAuth: true,
            blockUserRoll: true
        },
    },
    {
        path: "/:catchAll(.*)",
        component: () => import("../views/404.vue"),
        meta: {
            alias: "404 - Page Not Found",
        },
    },
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});

router.beforeEach(async (to, from, next) => {
    let login = from.name == "Login";
    let register = from.name == "Register";
    let dashboard = to.name == "Home";
    let allowUser = to.meta.blockUserRoll;
    let authenticated = store.state.user.email;

    store.commit("user/routerHistory", to.name);

    const authRoutes = ['Login', 'Register', 'LostPassword', 'ResetPassword', 'ActiveAccount', 'VerifyAccount'];
    
    if (authenticated && authRoutes.includes(to.name)) {
        return next({ name: "Home" });
    }

    if ((login || register) && dashboard) {
        if (authenticated) return next();
    }

    if (allowUser && store.state.user.role == 'user') return next({ name: "Home" });
    if (!to.meta.requiresAuth) return next();

    if (!authenticated && dashboard) {
        try {
            await store.dispatch("user/getUserInformation");
            authenticated = store.state.user.email;
        } catch (e) {
            authenticated = store.state.user.email;
        }
    }

    if (!authenticated) return next({ name: "Login" });
    if (authenticated) return next();
    return next();
});

router.afterEach((to, from) => {
    const pageTitle = to.meta.alias;
    const brandName = getBrandName();
    const page = pageTitle ? ` | ${pageTitle}` : '';
    document.title = `${brandName}${page}`;
});

export default router;
